import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page33() {
  useEffect(() => {
    document.title = "Маяк — Страница 32"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page31" />
        <ForwardLink href="/page33" />
      </div>

      <p style={{ textAlign: "right" }}>32.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Это к лучшему.
      </p>
      <p>Пауза.</p>
      <p>
        Понятно, что СТАРИК сожалеет. Но вместо того, чтобы зацикливаться<br/>
        на болезненном прошлом, он меняет тему.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Раз уж мы стали слишком дружны,<br/>
        Эфраим Уинслоу, скажи мне, чего<br/>
        лесорубу нужно от того, чтобы быть<br/>
        викки? Не хватает тишины<br/>
        на севере? Опилки зудят в одном месте?<br/>
        Бригадир посчитал тебя слишком горячим,<br/>
        чтобы доверить топор?
      </p>
      <p>
        Последний комментарий задевает МОЛОДОГО, но он старается<br/>
        не поддаваться этому чувству.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Как Вы говорите, я думаю,<br/>
        хватит с меня деревьев.
      </p>
      <p>СТАРИК подозрительно смотрит на него, пока закуривает трубку.</p>
      <p>МОЛОДОЙ сосредотачивается на своей сигарете. Поджигает. Затягивается.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        С тех пор, как я ушел от отца, ну... я брался<br/>
        за любую работу, за которую можно заплатить мужчине.<br/>
        Некоторыми я совсем не горжусь.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Так ты бродяга?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр! Просто ищу себя,<br/>
        поэтому продолжаю<br/>
        двигаться дальше. И я не из тех,<br/>
        кто оглядывается назад.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        В бегах?
      </p>
      <p>МОЛОДОЙ начинает защищаться. Он слишком много сказал?</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр -- теперь послушайте, сейчас -- Я<br/>
        имею в виду, нет ничего плохого в том, что человек<br/>
        начинает с чистого листа, начинает заново,<br/>
        ищет, как заработать на жизнь--
      </p>
      <p style={{ textAlign: "right" }}>32.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page31" />
        <ForwardLink href="/page33" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710020164/the-lighthouse-script/ctpx2glnmxmeaa8bg9jy.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page33;
